import Dashboard from "../components/dashboard";
import SvgIcons from "../../../shared/components/svgIcons";
import StudentDetails from "../components/studentDetails";


const dashboardRoute = [
  {
    path: "dashboard",
    element: <Dashboard />,
    link: "dashboard",
    name: "Dashboard",
    icon: SvgIcons.DashBoardIcon,
    index: 0,
  },
 {
    path: "dashboard/:id",
    element: <StudentDetails />,
  },
];
export default dashboardRoute;
